<template>
  <vb-modal
    :vb_options="{
      id: modal_id,
      title: name_label,
      body_class: 'room-modal',
      header_class: 'room-modal__header',
      centered: true,
      hide_footer: true,
      size: 'lg',
    }"
  >
    <carousel v-if="images.length" class="room-modal__gallery" :images="images" />

    <h5 class="room-modal__title" v-html="name_label"></h5>

    <p v-if="board_label" class="room-modal__board">
      <vb-icon :name="'cutlery'" :size="16" class="mr-1" />
      <span v-html="board_label"></span>
    </p>

    <p class="room-modal__description" v-html="description"></p>
  </vb-modal>
</template>

<script>
  import Carousel from '@/components/blocks/images/carousel.vue';

  const sentence_case = (value) => {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  };

  export default {
    name: 'room-modal',

    components: {
      carousel: Carousel,
    },

    props: {
      modal_id: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        default: '',
      },
      board: {
        type: String,
        default: '',
      },
      description: {
        type: String,
        default: '',
      },
      images: {
        type: Array,
        default: () => [],
      },
    },

    computed: {
      name_label() {
        return sentence_case(this.name);
      },

      board_label() {
        return sentence_case(this.board);
      },
    },
  };
</script>

<style lang="scss">
  .modal-header.vb-modal__header.room-modal__header {
    margin-bottom: 0;
  }

  .room-modal {
    &__gallery {
      margin-bottom: 1.25rem;

      .carousel__image {
        border-radius: $border-radius;
      }
    }

    &__title {
      font-size: 1.375rem;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 0;
    }

    &__board {
      display: flex;
      align-items: center;
      color: var(--secondary);
      font-size: $font-size-base;
      font-weight: $vb-font-weight-semibold;
      margin-top: $grid-gutter-width/6;
      margin-bottom: $grid-gutter-width/3;
    }

    &__description {
      font-size: $font-size-sm;
      margin-bottom: 0;
    }
  }
</style>
